import React, { useRef, useState, useEffect } from "react";
import AuthAPI from '~/api/authApi';
function VerificationCodeInput({ length = 6,
    onCompleteChange,
    apiUrl,
    onCallback,
    formId,
    onVerifyCode,
    onChangeCode,
    inputContainerClassName = "d-flex align-items-center gap-2 mb-3",
    errorClassName = "text-center mb-3 text-danger fw-bold fs-9"
}) {
    const inputsRef = useRef([]);

    const [codes, setCodes] = useState(Array(length).fill(""));
    const [error, setError] = useState(null);
    const handleInput = (e, index) => {
        const value = e.target.value;
        const newCodes = [...codes];
        if (/^\d$/.test(value)) {
            newCodes[index] = value;
            setCodes(newCodes);
            if (index < length - 1) {
                inputsRef.current[index + 1]?.focus();
            }
        } else {
            newCodes[index] = "";
            setCodes(newCodes);
        }
    };
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newCodes = [...codes];
            if (!newCodes[index] && index > 0) {
                newCodes[index - 1] = "";
                setCodes(newCodes);
                inputsRef.current[index - 1]?.focus();
            } else {
                newCodes[index] = "";
                setCodes(newCodes);
            }
        }
    };
    useEffect(() => {
        const isComplete = codes.every((v) => /^\d$/.test(v));
        if (onCompleteChange) {
            onCompleteChange(isComplete);
        }
        if (onChangeCode) {
            onChangeCode(codes.join(""));
        }
    }, [codes]);
    const onSubmit = (e) => {
        e.preventDefault();
        setError("");
        const codeString = codes.join("");
        if (codeString.length < length) {
            return;
        }
        if (apiUrl) {
            onVerifyCode && onVerifyCode(true);
            AuthAPI.verify2FaCode(`${apiUrl}/${codeString}`)
                .then((res) => {
                    if (!res.data?.Succeeded) {
                        setError(res.data?.Message);
                    }
                    onCallback && onCallback(res);
                })
                .catch((err) => {
                    setError("Failed to verify code.");
                })
                .finally(() => {
                    onVerifyCode && onVerifyCode(false)
                });
        }
    }
    return (
        <form onSubmit={onSubmit} id={formId} className="mt-3">
            {
                error && (
                    <div className={errorClassName}>
                        <span>{error}</span>
                    </div>
                )
            }
            <div className={inputContainerClassName}>
                {codes.map((code, i) => (
                    <input
                        key={i}
                        type="text"
                        maxLength={1}
                        className="px-2 text-center form-control"
                        value={code}
                        ref={(el) => (inputsRef.current[i] = el)}
                        onChange={(e) => handleInput(e, i)}
                        onKeyDown={(e) => handleKeyDown(e, i)}
                    />
                ))}
            </div>
        </form>
    );
}
export default VerificationCodeInput;